import { QueryHookOptions, useQuery } from '@apollo/client';
import query from '../../queries/orderDetails';
import { VehicleModel } from './useVehicleModels';

export interface OrderStatus {
  id: number;
  name: string;
}

export interface OrderPaymentItem {
  id: string;
  paidAmount: number;
  currency: string;
  createdAt: string;
}

export interface OrderPayment {
  id: number;
  paymentMethod: string;
  billingFirstName: string;
  billingLastName: string;
  billingAddress1: string;
  billingAddress2: string;
  billingCity: string;
  billingStateOrProvince: string;
  billingZipcode: string;
  billingCountry: string;
  orderPaymentItems: OrderPaymentItem[];
  createdAt: string;
}

export interface Order {
  orderNum: string;
  orderStatus: OrderStatus;
  vehicleModel: VehicleModel;
  orderPaymentCores: OrderPayment[];
  vehicleConfigurationCore: VehicleConfiguration
  createdAt: string;
  isOnWaitlist: boolean;
  waitlistJoinedAt: string;
  canUpgradeEdition: boolean;
  canDowngradeEdition: boolean;
}

interface UseOrderDetailResponse {
  orderDetails: Order;
}

interface UseOrderDetailRequest {
  confNum: string;
}

interface VehicleConfiguration {
  configurationNum: string;
  vehicleConfigurationItems: VehicleConfigurationItem[];
}

interface VehicleOption {
  id: number;
  price: number;
  vehicleOptionType: VehicleOptionType;
}

export interface VehicleConfigurationItem {
  id: number;
  quantity: number;
  vehicleOption: VehicleOption
}

interface VehicleOptionType {
  id: number;
  categoryCode: string;
  categoryName: string;
  typeCode: string;
  typeName: string;
}

export default function useOrderDetail(
  orderNum: string,
  options: QueryHookOptions<UseOrderDetailResponse, UseOrderDetailRequest> = {}
) {
  const { data, ...rest } = useQuery<
    UseOrderDetailResponse,
    UseOrderDetailRequest
  >(query, {
    ...options,
    variables: {
      confNum: orderNum
    }
  });

  const order = data?.orderDetails;

  return {
    order,
    ...rest
  };
}
